export default __webpack_public_path__ + "static/media/perkyjerky_texture.ac19fa99.jpg";